<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
        <v-card-title>
            User
        </v-card-title>
        <v-card-text>
             <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                 v-model="account.username"
                  label="Username *"
                  :rules="textRules"
                required
                ></v-text-field>

               
                <v-text-field
                  v-model="account.password"
                  v-if="state=='new'" 
                  label="Password *"
                  :rules="textRules"
                required
                ></v-text-field>

               
                
                <v-text-field
                  v-model="account.email"
                  label="email *"
                ></v-text-field>

                <v-autocomplete
                v-model="account.role"
                :items="roles"
                label="User Role"
                ></v-autocomplete>   
                <div class="pa-4 mb-10" v-if="account.role == 'cashier'">
                  Select Printing Option:
                
            <v-checkbox
                    v-model="selected_permission"
                    hide-details
                    label="Print Only"
                    value="Print Only"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selected_permission"
                    label="Cash Only"
                    hide-details
                    value="Cash Only"
                  ></v-checkbox>
                    <v-checkbox
                    v-model="selected_permission"
                    label="Credit Only"
                    value="Credit Only"
                    hide-details
                  ></v-checkbox>
                    
                </div>

                  <v-text-field
                    v-model="newpassword"
                    name="input-10-1"
                    label="Change Password"
                    hint="At least 8 characters"
                    counter
                    v-if="show1==true"
                  ></v-text-field>
                <v-btn block  v-if="state!='new'" @click="show1=true" color="darken-1" small dark>Change Password</v-btn>
             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="default" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    user: {
        type: Object,
        default: ()=>{ return {}}
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      account: {},
      newpassword:'',
      selected_permission:[],
      show1: false,
       roles: ['administrator', 'headpatcher', 'dispatcher', 'encoder', 'weigher', 'cashier'],
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      }
  },
  watch: {
    show(v) {
      if (!v) {
        this.newpassword = ''
        this.show1=false
        this.selected_permission =[]
      } else {
        this.user.password =''
        this.getUserData()
      }
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.emitToParent(this.state)
          this.show1 = false
        }
      },
    getUserData(){
       this.$http.post("user/details", {id: this.user.id}).then(response => {
              response.data.account != null?this.account = response.data.account:this.account={}
               this.account.password =''
               if(this.account.role == 'cashier') {
                 this.selected_permission = JSON.parse(this.account.code)
               } 
          }).catch(e => {
           console.log(e.data)
         })
    },
    emitToParent (action) {
      if(this.show1) {
        this.account.password = this.newpassword
      } 
      this.account.code = ''
      if(this.selected_permission.length > 0) {
        this.account.code = JSON.stringify(this.selected_permission)
      } 
      console.log(this.account)
      this.$emit('DialogEvent', {action: action, user:this.account})
    }
  }
}
</script>
